import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGElement from './SVGElement';
import colors from '../../styling/colors';

export default class MagnifyingGlass extends Component {
  static propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    strokeColor: PropTypes.string,
    width: PropTypes.string,
  };

  static defaultProps = {
    height: '1.5rem',
    strokeColor: colors('Silver'),
    width: '1.5rem',
  };

  render() {
    const { className, height, strokeColor, width } = this.props;

    return (
      <SVGElement
        className={className}
        height={height}
        viewBox="0 0 24 24"
        width={width}
      >
        <path
          fill={strokeColor}
          d="M20.42,19.5,17,16.17a8.1,8.1,0,1,0-.7.72l3.4,3.32a.5.5,0,1,0,.7-.71ZM3.93,11a7,7,0,1,1,7,7A7,7,0,0,1,3.93,11Z"
        />
        <rect fill="none" width="24" height="24" />
      </SVGElement>
    );
  }
}
